<template>
  <el-dialog
    id="leaderEngagementDialog"
    width="600px"
    :visible.sync="showLocal"
    :show-close="true"
  >
    <div
      slot="title"
      class="title"
    >
      {{ $t("component.engagementPaused.invitationsUnavailable") }}
    </div>

    <div class="content">
      {{ $t("component.engagementPaused.invitationsUnavailableDescription") }}
      <br /><br />
      <i18n path="component.engagementPaused.invitationsUnavailableDescription2">
        <template #email>
          <a
            style="color: #409eff;"
            href="mailto:Support@GlobalCoachGroup.com"
          >Support@GlobalCoachGroup.com</a>
        </template>
      </i18n>
    </div>

    <div
      slot="footer"
      style="text-align: center;"
    >
      <el-button
        type="primary"
        round
        @click="goToManageEngagement"
      >
        {{ $t('common.manageEngagement') }}
      </el-button>
      <el-button
        type="primary"
        round
        @click="goToSubscription"
      >
        {{ $t('common.upgradePlan') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
// import dialog from '@/mixins/dialog';

export default {
  name: 'LeaderEngagementPaused',

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    showLocal: false,
  }),

  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (val) this.showLocal = true;
      },
    },
  },

  methods: {
    goToManageEngagement() {
      this.$router.push({ name: 'myLeaders', query: { manageEngagement: true } }).catch((err) => {});
    },

    goToSubscription() {
      window.open(`${process.env.VUE_APP_CAS_CLIENT}/settings/subscription`, '_blank');
    },
  },
};
</script>
